import * as React from 'react';
import { SheetsDirective, SheetDirective, ColumnsDirective, RangesDirective, RangeDirective } from '@syncfusion/ej2-react-spreadsheet';
import { RowsDirective, RowDirective, CellsDirective, CellDirective, ColumnDirective } from '@syncfusion/ej2-react-spreadsheet';
import { SpreadsheetComponent } from '@syncfusion/ej2-react-spreadsheet';
import { defaultData } from './data';
import './spreadsheet.css';

function Spreadsheet() {
    let spreadsheet;
    const boldRight = { fontWeight: 'bold', textAlign: 'right' };
    const bold = { fontWeight: 'bold' };

    const onCreated = () => {
        spreadsheet.cellFormat({ fontWeight: 'bold', textAlign: 'center', verticalAlign: 'middle' }, 'A1:F1');
        spreadsheet.numberFormat('$#,##0.00', 'F2:F31');
        spreadsheet.numberFormat('m/d/yyyy', 'E2:E30');
    };

    return (
        <div style={{ 
            height: '100%', 
            width: '100%', 
            position: 'relative',
            overflow: 'auto',
            backgroundColor: 'white' 
        }}>
            <SpreadsheetComponent 
                openUrl='https://services.syncfusion.com/react/production/api/spreadsheet/open'
                saveUrl='https://services.syncfusion.com/react/production/api/spreadsheet/save'
                ref={(ssObj) => { spreadsheet = ssObj; }}
                created={onCreated.bind(this)}
                height='100%'
                width='100%'
            >
                <SheetsDirective>
                    <SheetDirective name="Car Sales Report">
                        <RangesDirective>
                            <RangeDirective dataSource={defaultData}></RangeDirective>
                        </RangesDirective>
                        <RowsDirective>
                            <RowDirective index={30}>
                                <CellsDirective>
                                    <CellDirective index={4} value="Total Amount:" style={boldRight}></CellDirective>
                                    <CellDirective formula="=SUM(F2:F30)" style={bold}></CellDirective>
                                </CellsDirective>
                            </RowDirective>
                        </RowsDirective>
                        <ColumnsDirective>
                            <ColumnDirective width={180}></ColumnDirective>
                            <ColumnDirective width={130}></ColumnDirective>
                            <ColumnDirective width={130}></ColumnDirective>
                            <ColumnDirective width={180}></ColumnDirective>
                            <ColumnDirective width={130}></ColumnDirective>
                            <ColumnDirective width={120}></ColumnDirective>
                        </ColumnsDirective>
                    </SheetDirective>
                </SheetsDirective>
            </SpreadsheetComponent>
        </div>
    );
}

export default Spreadsheet;